import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI, fileUrl, platformAPI } from '../../services/api';
import toast from 'react-hot-toast';
import { Mail, ArrowRight, Shield } from 'lucide-react';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(null); // { message, dev_reset_url? }
  const [logoPath, setLogoPath] = useState(null);

  React.useEffect(() => {
    platformAPI.getPublicSettings().then(d => { if (d.logo_path) setLogoPath(d.logo_path); }).catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await authAPI.forgotPassword({ email });
      setSent(res);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-layout" style={{ justifyContent: 'center', background: 'linear-gradient(135deg, #eef2ff 0%, #fdf2f8 100%)' }}>
      <div className="auth-form-panel" style={{ maxWidth: 520 }}>
        <div className="auth-form-wrapper">
          <div className="auth-card">
            <div className="auth-card-header">
              <div className="auth-form-logo">
                {logoPath ? (
                  <img src={fileUrl(logoPath)} alt="Logo" className="auth-form-logo-img" style={{ objectFit: 'contain' }} />
                ) : (
                  <img src="/favicon.svg" alt="LedgerPro" className="auth-form-logo-img" />
                )}
              </div>
              <h2>Forgot your password?</h2>
              <p>Enter your email or username and we'll send you a reset link.</p>
            </div>
            <div className="auth-card-body">
              {!sent ? (
                <form onSubmit={handleSubmit}>
                  <div className="auth-field">
                    <label>Email or Username</label>
                    <div className="auth-input-icon">
                      <Mail size={18} className="auth-input-icon-svg" />
                      <input className="auth-input" type="text" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@company.com" autoFocus required />
                    </div>
                  </div>
                  <button className="auth-submit auth-submit-primary" type="submit" disabled={loading}>
                    {loading ? (
                      <><span className="spinner" style={{ width: 16, height: 16, borderWidth: 2 }} /> Sending...</>
                    ) : (
                      <>Send reset link <ArrowRight size={16} /></>
                    )}
                  </button>
                </form>
              ) : (
                <div style={{ textAlign: 'center', padding: '10px 0' }}>
                  <div style={{ fontSize: 40, marginBottom: 10 }}>📧</div>
                  <h3 style={{ margin: '0 0 8px', color: '#166534' }}>Check your inbox</h3>
                  <p style={{ margin: '0 0 18px', fontSize: 13.5, color: '#64748b', lineHeight: 1.6 }}>{sent.message}</p>
                  {sent.dev_reset_url && (
                    <>
                      <div style={{ background: '#fefce8', border: '1px solid #fde047', borderRadius: 8, padding: 12, fontSize: 12.5, color: '#854d0e', marginBottom: 14 }}>
                        Dev mode — SMTP not configured. Use the direct link below:
                      </div>
                      <a href={sent.dev_reset_url}>
                        <button className="auth-submit auth-submit-primary" type="button">Open reset link</button>
                      </a>
                    </>
                  )}
                </div>
              )}

              <div className="auth-divider"><span><Shield size={11} style={{ verticalAlign: '-1px' }} /> Reset links expire after 1 hour</span></div>

              <Link to="/login" style={{ textDecoration: 'none' }}>
                <button className="auth-submit" type="button" style={{ background: '#f3f4f6', color: '#374151', border: '1px solid #e5e7eb' }}>
                  Back to Sign In
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
